/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Pwrdby.QuickMD.Admins.Api
 * OpenAPI spec version: 1.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useSuspenseInfiniteQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ErrorApiOutContract,
  ErrorDescription,
  GetPatientsPatientIdLogsAuditParams,
  GetUtilitiesLogsAccessParams,
  MessageApiContract,
  PatientAuditLogAdminApiOutContract,
  PatientMessageStaffApiContract,
  PhoneApiContract
} from '../pwrdbyQuickMDAdminsApi.schemas';

import { fetcher } from '@quickmd-llc/frontend-utils';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const postUtilitiesValidatephonenumber = (
    phoneApiContract: PhoneApiContract,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<void>(
      {url: `https://admins-api.api.quick.md/api/v1/utilities/validatephonenumber`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: phoneApiContract, signal
    },
      options);
    }
  


export const getPostUtilitiesValidatephonenumberMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUtilitiesValidatephonenumber>>, TError,{data: PhoneApiContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postUtilitiesValidatephonenumber>>, TError,{data: PhoneApiContract}, TContext> => {

const mutationKey = ['postUtilitiesValidatephonenumber'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUtilitiesValidatephonenumber>>, {data: PhoneApiContract}> = (props) => {
          const {data} = props ?? {};

          return  postUtilitiesValidatephonenumber(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUtilitiesValidatephonenumberMutationResult = NonNullable<Awaited<ReturnType<typeof postUtilitiesValidatephonenumber>>>
    export type PostUtilitiesValidatephonenumberMutationBody = PhoneApiContract
    export type PostUtilitiesValidatephonenumberMutationError = void | ErrorApiOutContract

    export const usePostUtilitiesValidatephonenumber = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUtilitiesValidatephonenumber>>, TError,{data: PhoneApiContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postUtilitiesValidatephonenumber>>,
        TError,
        {data: PhoneApiContract},
        TContext
      > => {

      const mutationOptions = getPostUtilitiesValidatephonenumberMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getUtilitiesLogsAccess = (
    params?: GetUtilitiesLogsAccessParams,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<MessageApiContract[]>(
      {url: `https://admins-api.api.quick.md/api/v1/utilities/logs/access`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetUtilitiesLogsAccessInfiniteQueryKey = (params?: GetUtilitiesLogsAccessParams,) => {
    return [
    'infinite', `https://admins-api.api.quick.md/api/v1/utilities/logs/access`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetUtilitiesLogsAccessQueryKey = (params?: GetUtilitiesLogsAccessParams,) => {
    return [
    `https://admins-api.api.quick.md/api/v1/utilities/logs/access`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetUtilitiesLogsAccessInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getUtilitiesLogsAccess>>>, TError = ErrorDescription | void | ErrorApiOutContract>(params?: GetUtilitiesLogsAccessParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getUtilitiesLogsAccess>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUtilitiesLogsAccessInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUtilitiesLogsAccess>>> = ({ signal }) => getUtilitiesLogsAccess(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getUtilitiesLogsAccess>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUtilitiesLogsAccessInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getUtilitiesLogsAccess>>>
export type GetUtilitiesLogsAccessInfiniteQueryError = ErrorDescription | void | ErrorApiOutContract


export function useGetUtilitiesLogsAccessInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getUtilitiesLogsAccess>>>, TError = ErrorDescription | void | ErrorApiOutContract>(
 params: undefined |  GetUtilitiesLogsAccessParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getUtilitiesLogsAccess>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUtilitiesLogsAccess>>,
          TError,
          Awaited<ReturnType<typeof getUtilitiesLogsAccess>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUtilitiesLogsAccessInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getUtilitiesLogsAccess>>>, TError = ErrorDescription | void | ErrorApiOutContract>(
 params?: GetUtilitiesLogsAccessParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getUtilitiesLogsAccess>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUtilitiesLogsAccess>>,
          TError,
          Awaited<ReturnType<typeof getUtilitiesLogsAccess>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUtilitiesLogsAccessInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getUtilitiesLogsAccess>>>, TError = ErrorDescription | void | ErrorApiOutContract>(
 params?: GetUtilitiesLogsAccessParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getUtilitiesLogsAccess>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetUtilitiesLogsAccessInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getUtilitiesLogsAccess>>>, TError = ErrorDescription | void | ErrorApiOutContract>(
 params?: GetUtilitiesLogsAccessParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getUtilitiesLogsAccess>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUtilitiesLogsAccessInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetUtilitiesLogsAccessInfiniteQuery = async <TData = Awaited<ReturnType<typeof getUtilitiesLogsAccess>>, TError = ErrorDescription | void | ErrorApiOutContract>(
 queryClient: QueryClient, params?: GetUtilitiesLogsAccessParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getUtilitiesLogsAccess>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetUtilitiesLogsAccessInfiniteQueryOptions(params,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetUtilitiesLogsAccessQueryOptions = <TData = Awaited<ReturnType<typeof getUtilitiesLogsAccess>>, TError = ErrorDescription | void | ErrorApiOutContract>(params?: GetUtilitiesLogsAccessParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUtilitiesLogsAccess>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUtilitiesLogsAccessQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUtilitiesLogsAccess>>> = ({ signal }) => getUtilitiesLogsAccess(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUtilitiesLogsAccess>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUtilitiesLogsAccessQueryResult = NonNullable<Awaited<ReturnType<typeof getUtilitiesLogsAccess>>>
export type GetUtilitiesLogsAccessQueryError = ErrorDescription | void | ErrorApiOutContract


export function useGetUtilitiesLogsAccess<TData = Awaited<ReturnType<typeof getUtilitiesLogsAccess>>, TError = ErrorDescription | void | ErrorApiOutContract>(
 params: undefined |  GetUtilitiesLogsAccessParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUtilitiesLogsAccess>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUtilitiesLogsAccess>>,
          TError,
          Awaited<ReturnType<typeof getUtilitiesLogsAccess>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUtilitiesLogsAccess<TData = Awaited<ReturnType<typeof getUtilitiesLogsAccess>>, TError = ErrorDescription | void | ErrorApiOutContract>(
 params?: GetUtilitiesLogsAccessParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUtilitiesLogsAccess>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUtilitiesLogsAccess>>,
          TError,
          Awaited<ReturnType<typeof getUtilitiesLogsAccess>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUtilitiesLogsAccess<TData = Awaited<ReturnType<typeof getUtilitiesLogsAccess>>, TError = ErrorDescription | void | ErrorApiOutContract>(
 params?: GetUtilitiesLogsAccessParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUtilitiesLogsAccess>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetUtilitiesLogsAccess<TData = Awaited<ReturnType<typeof getUtilitiesLogsAccess>>, TError = ErrorDescription | void | ErrorApiOutContract>(
 params?: GetUtilitiesLogsAccessParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUtilitiesLogsAccess>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUtilitiesLogsAccessQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetUtilitiesLogsAccessQuery = async <TData = Awaited<ReturnType<typeof getUtilitiesLogsAccess>>, TError = ErrorDescription | void | ErrorApiOutContract>(
 queryClient: QueryClient, params?: GetUtilitiesLogsAccessParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUtilitiesLogsAccess>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetUtilitiesLogsAccessQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetUtilitiesLogsAccessSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getUtilitiesLogsAccess>>, TError = ErrorDescription | void | ErrorApiOutContract>(params?: GetUtilitiesLogsAccessParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUtilitiesLogsAccess>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUtilitiesLogsAccessQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUtilitiesLogsAccess>>> = ({ signal }) => getUtilitiesLogsAccess(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUtilitiesLogsAccess>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUtilitiesLogsAccessSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getUtilitiesLogsAccess>>>
export type GetUtilitiesLogsAccessSuspenseQueryError = ErrorDescription | void | ErrorApiOutContract


export function useGetUtilitiesLogsAccessSuspense<TData = Awaited<ReturnType<typeof getUtilitiesLogsAccess>>, TError = ErrorDescription | void | ErrorApiOutContract>(
 params: undefined |  GetUtilitiesLogsAccessParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUtilitiesLogsAccess>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUtilitiesLogsAccessSuspense<TData = Awaited<ReturnType<typeof getUtilitiesLogsAccess>>, TError = ErrorDescription | void | ErrorApiOutContract>(
 params?: GetUtilitiesLogsAccessParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUtilitiesLogsAccess>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUtilitiesLogsAccessSuspense<TData = Awaited<ReturnType<typeof getUtilitiesLogsAccess>>, TError = ErrorDescription | void | ErrorApiOutContract>(
 params?: GetUtilitiesLogsAccessParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUtilitiesLogsAccess>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetUtilitiesLogsAccessSuspense<TData = Awaited<ReturnType<typeof getUtilitiesLogsAccess>>, TError = ErrorDescription | void | ErrorApiOutContract>(
 params?: GetUtilitiesLogsAccessParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUtilitiesLogsAccess>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUtilitiesLogsAccessSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetUtilitiesLogsAccessSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getUtilitiesLogsAccess>>>, TError = ErrorDescription | void | ErrorApiOutContract>(params?: GetUtilitiesLogsAccessParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getUtilitiesLogsAccess>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUtilitiesLogsAccessInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUtilitiesLogsAccess>>> = ({ signal }) => getUtilitiesLogsAccess(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getUtilitiesLogsAccess>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUtilitiesLogsAccessSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getUtilitiesLogsAccess>>>
export type GetUtilitiesLogsAccessSuspenseInfiniteQueryError = ErrorDescription | void | ErrorApiOutContract


export function useGetUtilitiesLogsAccessSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getUtilitiesLogsAccess>>>, TError = ErrorDescription | void | ErrorApiOutContract>(
 params: undefined |  GetUtilitiesLogsAccessParams, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getUtilitiesLogsAccess>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUtilitiesLogsAccessSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getUtilitiesLogsAccess>>>, TError = ErrorDescription | void | ErrorApiOutContract>(
 params?: GetUtilitiesLogsAccessParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getUtilitiesLogsAccess>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUtilitiesLogsAccessSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getUtilitiesLogsAccess>>>, TError = ErrorDescription | void | ErrorApiOutContract>(
 params?: GetUtilitiesLogsAccessParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getUtilitiesLogsAccess>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetUtilitiesLogsAccessSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getUtilitiesLogsAccess>>>, TError = ErrorDescription | void | ErrorApiOutContract>(
 params?: GetUtilitiesLogsAccessParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getUtilitiesLogsAccess>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUtilitiesLogsAccessSuspenseInfiniteQueryOptions(params,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postUtilitiesLogsAccess = (
    patientMessageStaffApiContract: PatientMessageStaffApiContract,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<void>(
      {url: `https://admins-api.api.quick.md/api/v1/utilities/logs/access`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: patientMessageStaffApiContract, signal
    },
      options);
    }
  


export const getPostUtilitiesLogsAccessMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUtilitiesLogsAccess>>, TError,{data: PatientMessageStaffApiContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postUtilitiesLogsAccess>>, TError,{data: PatientMessageStaffApiContract}, TContext> => {

const mutationKey = ['postUtilitiesLogsAccess'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUtilitiesLogsAccess>>, {data: PatientMessageStaffApiContract}> = (props) => {
          const {data} = props ?? {};

          return  postUtilitiesLogsAccess(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUtilitiesLogsAccessMutationResult = NonNullable<Awaited<ReturnType<typeof postUtilitiesLogsAccess>>>
    export type PostUtilitiesLogsAccessMutationBody = PatientMessageStaffApiContract
    export type PostUtilitiesLogsAccessMutationError = void | ErrorApiOutContract

    export const usePostUtilitiesLogsAccess = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUtilitiesLogsAccess>>, TError,{data: PatientMessageStaffApiContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postUtilitiesLogsAccess>>,
        TError,
        {data: PatientMessageStaffApiContract},
        TContext
      > => {

      const mutationOptions = getPostUtilitiesLogsAccessMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getPatientsPatientIdLogsAudit = (
    patientId: string,
    params?: GetPatientsPatientIdLogsAuditParams,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<PatientAuditLogAdminApiOutContract[]>(
      {url: `https://admins-api.api.quick.md/api/v1/patients/${encodeURIComponent(String(patientId))}/logs/audit`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetPatientsPatientIdLogsAuditInfiniteQueryKey = (patientId?: string,
    params?: GetPatientsPatientIdLogsAuditParams,) => {
    return [
    'infinite', `https://admins-api.api.quick.md/api/v1/patients/${patientId}/logs/audit`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetPatientsPatientIdLogsAuditQueryKey = (patientId?: string,
    params?: GetPatientsPatientIdLogsAuditParams,) => {
    return [
    `https://admins-api.api.quick.md/api/v1/patients/${patientId}/logs/audit`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetPatientsPatientIdLogsAuditInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>>, TError = ErrorDescription | void | ErrorApiOutContract>(patientId: string,
    params?: GetPatientsPatientIdLogsAuditParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdLogsAuditInfiniteQueryKey(patientId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>> = ({ signal }) => getPatientsPatientIdLogsAudit(patientId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdLogsAuditInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>>
export type GetPatientsPatientIdLogsAuditInfiniteQueryError = ErrorDescription | void | ErrorApiOutContract


export function useGetPatientsPatientIdLogsAuditInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>>, TError = ErrorDescription | void | ErrorApiOutContract>(
 patientId: string,
    params: undefined |  GetPatientsPatientIdLogsAuditParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdLogsAuditInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>>, TError = ErrorDescription | void | ErrorApiOutContract>(
 patientId: string,
    params?: GetPatientsPatientIdLogsAuditParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdLogsAuditInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>>, TError = ErrorDescription | void | ErrorApiOutContract>(
 patientId: string,
    params?: GetPatientsPatientIdLogsAuditParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsPatientIdLogsAuditInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>>, TError = ErrorDescription | void | ErrorApiOutContract>(
 patientId: string,
    params?: GetPatientsPatientIdLogsAuditParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdLogsAuditInfiniteQueryOptions(patientId,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetPatientsPatientIdLogsAuditInfiniteQuery = async <TData = Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>, TError = ErrorDescription | void | ErrorApiOutContract>(
 queryClient: QueryClient, patientId: string,
    params?: GetPatientsPatientIdLogsAuditParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsPatientIdLogsAuditInfiniteQueryOptions(patientId,params,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsPatientIdLogsAuditQueryOptions = <TData = Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>, TError = ErrorDescription | void | ErrorApiOutContract>(patientId: string,
    params?: GetPatientsPatientIdLogsAuditParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdLogsAuditQueryKey(patientId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>> = ({ signal }) => getPatientsPatientIdLogsAudit(patientId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdLogsAuditQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>>
export type GetPatientsPatientIdLogsAuditQueryError = ErrorDescription | void | ErrorApiOutContract


export function useGetPatientsPatientIdLogsAudit<TData = Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>, TError = ErrorDescription | void | ErrorApiOutContract>(
 patientId: string,
    params: undefined |  GetPatientsPatientIdLogsAuditParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdLogsAudit<TData = Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>, TError = ErrorDescription | void | ErrorApiOutContract>(
 patientId: string,
    params?: GetPatientsPatientIdLogsAuditParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdLogsAudit<TData = Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>, TError = ErrorDescription | void | ErrorApiOutContract>(
 patientId: string,
    params?: GetPatientsPatientIdLogsAuditParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsPatientIdLogsAudit<TData = Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>, TError = ErrorDescription | void | ErrorApiOutContract>(
 patientId: string,
    params?: GetPatientsPatientIdLogsAuditParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdLogsAuditQueryOptions(patientId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetPatientsPatientIdLogsAuditQuery = async <TData = Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>, TError = ErrorDescription | void | ErrorApiOutContract>(
 queryClient: QueryClient, patientId: string,
    params?: GetPatientsPatientIdLogsAuditParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsPatientIdLogsAuditQueryOptions(patientId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsPatientIdLogsAuditSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>, TError = ErrorDescription | void | ErrorApiOutContract>(patientId: string,
    params?: GetPatientsPatientIdLogsAuditParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdLogsAuditQueryKey(patientId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>> = ({ signal }) => getPatientsPatientIdLogsAudit(patientId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdLogsAuditSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>>
export type GetPatientsPatientIdLogsAuditSuspenseQueryError = ErrorDescription | void | ErrorApiOutContract


export function useGetPatientsPatientIdLogsAuditSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>, TError = ErrorDescription | void | ErrorApiOutContract>(
 patientId: string,
    params: undefined |  GetPatientsPatientIdLogsAuditParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdLogsAuditSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>, TError = ErrorDescription | void | ErrorApiOutContract>(
 patientId: string,
    params?: GetPatientsPatientIdLogsAuditParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdLogsAuditSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>, TError = ErrorDescription | void | ErrorApiOutContract>(
 patientId: string,
    params?: GetPatientsPatientIdLogsAuditParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsPatientIdLogsAuditSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>, TError = ErrorDescription | void | ErrorApiOutContract>(
 patientId: string,
    params?: GetPatientsPatientIdLogsAuditParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdLogsAuditSuspenseQueryOptions(patientId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetPatientsPatientIdLogsAuditSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>>, TError = ErrorDescription | void | ErrorApiOutContract>(patientId: string,
    params?: GetPatientsPatientIdLogsAuditParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdLogsAuditInfiniteQueryKey(patientId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>> = ({ signal }) => getPatientsPatientIdLogsAudit(patientId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdLogsAuditSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>>
export type GetPatientsPatientIdLogsAuditSuspenseInfiniteQueryError = ErrorDescription | void | ErrorApiOutContract


export function useGetPatientsPatientIdLogsAuditSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>>, TError = ErrorDescription | void | ErrorApiOutContract>(
 patientId: string,
    params: undefined |  GetPatientsPatientIdLogsAuditParams, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdLogsAuditSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>>, TError = ErrorDescription | void | ErrorApiOutContract>(
 patientId: string,
    params?: GetPatientsPatientIdLogsAuditParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdLogsAuditSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>>, TError = ErrorDescription | void | ErrorApiOutContract>(
 patientId: string,
    params?: GetPatientsPatientIdLogsAuditParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsPatientIdLogsAuditSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>>, TError = ErrorDescription | void | ErrorApiOutContract>(
 patientId: string,
    params?: GetPatientsPatientIdLogsAuditParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdLogsAudit>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdLogsAuditSuspenseInfiniteQueryOptions(patientId,params,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




